import React from 'react'
import Grid from '@mui/material/Grid'
import Text from '../../components/Text'
import Box from '@mui/material/Box'
import PricingPlan, { allPricingPlans } from './PricingPlan'
import competitionStore from '../../stores/competitionStore'
import { observer } from 'mobx-react-lite'
import { status } from '../../utils/constants'
import LoadingComponent from '../../components/LoadingComponent'

const PricingBody = () => {
  return (
    <Box mb={8}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Text weight="bold" variant="large" center mt={3} mb={3}>
            Subscription Plans
          </Text>
        </Grid>
        {competitionStore.subscriptionOptionsStatus === status.LOADING && (
          <Grid item xs={12}>
            <LoadingComponent message="Loading subscription plans..." />
          </Grid>
        )}
        {!competitionStore.subscriptionOptions ? null : allPricingPlans(competitionStore.subscriptionOptions).map((pricingPlan, i) => (
          <PricingPlan {...pricingPlan} key={i} />
        ))}
      </Grid>
    </Box>
  )
}

export default observer(PricingBody)
